import $ from 'jquery';

if( $( '.email-wise' ).length ) {
  $( '.email-wise' ).hide();
}

//this adds the page info and theiq questions into the
//comment section of the lasso list

$( document ).on( 'submit', '#showhomes-form', function () {
  let homeInfo = $('#form-reveal').data( 'title' );

  let fpQs = $( '#floorplan-questions').val();

  $( '#home-comments').val(function() {
      return 'Interested in Home: ' + homeInfo + ', Questions: ' + fpQs;
    })
});

//this updates the realtor form to go to the correct lasso list
$( document ).on( 'click',  '.lasso-id-update label', function( e ) {
  let lassoid = $( this ).data( 'community-id' );
  $( '.fill-lasso-id').val( lassoid );
})

//this updates the repatcha after the form is dynamically loaded
// $( document ).on( 'submit', '#showhomes-form', function( e ) {
//   e.preventDefault();
//   getRecaptchaToken( this );
// })

//this updates the popups to add the communities their interested in
//into the comments section of the general lasso list
const pageInfo = $( '#community-comments').val();

$( '.community-comments-update input' ).on( 'change', function( e ) {

  let communityVals = $('input:checkbox[name=Communities]:checked').map(function() {
      return $( this ).data( 'community' );
    }).get();

    $( '#community-comments').val(function() {
      return pageInfo + ', Interested in Communities: ' + communityVals;
    })
})

//this is the thank you response after the info is sent to lasso
let hash = window.location.hash;

if (  hash && hash.startsWith( '#!thanks' )  ) {

  if( ( '.contact-form-container' ).length ) {

    $('body').removeClass('no-scroll');
    window.location='#inquiry-contact';

    $( '.contact-form-container' )
    .animate( { opacity: 0 }, 400, function() {
      $( this ).children( ).addClass( 'hide' );
      $( this ).children( '.form-thank-you' ).removeClass( 'hide' );
    })
    .animate( { opacity: 1 }, 400 );
  }
}

// $( '.qp-contact' ).on( 'click', function() {
//   $( '.qp-form-thank-you' ).addClass( 'hide' );
//   $( '.qp-register-form-js' ).removeClass( 'hide' );
// })

if( $( '.form-reveal' ).length ) {

  let formHeadline = $( '.form-data' ).data('form-headline' );
  let communityInfoArray = [];
  let communityInfo, lassoId;

 $( '.community-info' ).each( function() {

    let communitySlug = $( this ).data( 'slug' );
    let communityName = $( this ).data( 'name' );
    lassoId = $( this ).data( 'lasso-id' );
    let input = `<input type="radio" name="communities" value="${ lassoId }" id="${ communitySlug }">
      <label for="${ communitySlug }" data-community-id="${ lassoId }">${ communityName }</label>
      `
      communityInfoArray += input;
  });

  if( $( '.community-info' ).length ) {
    communityInfo =
    // `<input type="hidden" class="fill-lasso-id" name="ProjectID" value="21455" />
    `<div class="input-wrapper drop-down flex text-black">
    <div class="dropdown-el lasso-id-update">
      <input type="radio" name="communities" value="view-all" id="all-communities" checked>
      <label class="view-all" for="all-communities" data-community-id="21559" >Available Communities</label>
        ${ communityInfoArray }
      </div>
  </div>`
  }

  // let formStructure =
  // `<form action="" method="POST" class="register-form-js" id="showhomes-form" aria-label="showhomes form">

  //   <input type="hidden" name="wise" value="">
  //   <input type="hidden" name="domainAccountId" value="LAS-908912-01" />
  //   <input type="hidden" class="showhome-name" name="showhomeName" value="${ formHeadline }" />
  //   <input type="hidden" name="guid" value="" />

  //   <div class="input-wrapper email-wise hide">
  //     <input type="text" name="email-wise" id="email" placeholder="Your email" autocomplete="nope" tabindex="-1">
  //   </div>

  //   <div class="input-wrapper flex-column">
  //     <input size="40" aria-required="true" aria-invalid="false" placeholder="First Name *" value="" type="text" name="FirstName" required>
  //     <input size="40" aria-required="true" aria-invalid="false" placeholder="Last Name *" value="" type="text" name="LastName" required>
  //     <input size="40" aria-required="true" aria-invalid="false" placeholder="Email *" value="" type="email" name="Emails[Primary]" required>
  //     <input size="40" aria-invalid="false" placeholder="Phone" value="" type="phone" name="Phones[Home]">
  //   </div>
  //   ${ communityInfo }
  //   <div class="input-wrapper">
  //     <div class="full-width">
  //       <textarea cols="40" rows="2" aria-required="true" aria-invalid="false" value="" placeholder="Questions?" name="Comments" id="floorplan-questions"></textarea>
  //     </div>
  //   </div>
  //   <input type="hidden" name="Comments" value="" id="home-comments">
  //   <input type="hidden" name="recaptcha_response" class="recaptcha-response" />
  //   <p class="p-small text-white mb-16 center">By clicking send you agree to our <a class="p-small underline" rel="noopener noreferrer" target="_blank" href="/privacy-policy">Privacy Policy</a></p>
  //   <input class="button button-light center" type="submit" value="Send" id="showhomes-submit">
  //   </form>`

  $('#communities').html( communityInfo );

  $( '#form-reveal' ).on( 'click', function() {

    $( '.form-reveal' ).show(); //html( formStructure );
    $('.register-form-js').show();
    $( this ).hide();

    if ( $( '.close-form' ).length && $( '.close-form' ).hasClass( 'hidden' ) ){
      $( '.close-form' ).removeClass('hidden')

      $( '.close-form' ).on('click', function(){
        $( '.close-form' ).addClass('hidden')
        // $( '.form-reveal' ).html( '' );
        $( '#form-reveal' ).show();
        $('.register-form-js').hide();
      })
    }
    grecaptcha.ready(function() {
      grecaptcha.execute('6LceXagnAAAAAINgRseZXNHfLKeihIWkH_Go1wTX', { action: 'submit' }).then(function(token) {
        document.querySelectorAll(".recaptcha-response").forEach(elem => (elem.value = token))
      });
    });
  })
}
